import {
    useStyles,
    ProfileNavigation,
    Flex,
    pxToRem,
    pxArrayToRem,
} from '@archipro-design/aria';
import type {
    ShorthandValue,
    ProfileNavigationItemProps,
    ShorthandCollection,
} from '@archipro-design/aria';
import * as S from './BoardListFilterNav.style';
import { useCurrentTabPath } from '~/modules/professional/hook/use-current-tab-path';
import { useMatchesHandleData } from '~/modules/root/hook';
import { Link } from '@remix-run/react';
import {
    DESIGN_BOARD_HOME_LINK,
    DESIGN_BOARD_ALL_PINS_LINK,
} from '~/modules/design-board/config';
import {
    useBoardFilterDropdown,
    useGetStartedAction,
} from '~/modules/design-board/hook';
import { useSaveToDesignBoardContext } from '~/modules/design-board/component/context';
import { BoardListFilterDrawerContent } from '~/modules/design-board/component/shared/BoardListFilterDrawerContent';

interface BoardListFilterNavProp {
    filterButton?: ShorthandValue<ProfileNavigationItemProps>;
    itemButtons?: ShorthandCollection<ProfileNavigationItemProps>;
    toggleFilterDrawer?: () => void;
}

export const BoardListFilterNav: React.FC<BoardListFilterNavProp> = ({
    itemButtons,
}) => {
    const currentTabPath = useCurrentTabPath();
    const { css } = useStyles({ currentTabPath });
    const isBoardListPage = useMatchesHandleData('isBoardListPage', false);
    const { dispatch } = useSaveToDesignBoardContext();
    const { itemsWithCount, roleType } = useBoardFilterDropdown();

    const navFilterButton = {
        children: '',
        transparent: true,
        onClick: () => {
            !!itemsWithCount &&
                dispatch({
                    type: 'OpenDrawer',
                    payload: {
                        drawerAnchor: 'left',
                        drawerChild: (
                            <BoardListFilterDrawerContent
                                itemsWithCount={itemsWithCount}
                                roleType={roleType}
                            />
                        ),
                        drawerContentClassName: css(
                            S.FilterDrawerContentWrapper
                        ),
                    },
                });
        },
    };

    const { newBoardButton } = useGetStartedAction();

    const navItemButtons: ShorthandCollection<ProfileNavigationItemProps> = [
        {
            children: 'Boards',
            selected: isBoardListPage,
            as: Link,
            to: DESIGN_BOARD_HOME_LINK,
            preventScrollReset: true,
        },

        {
            children: 'Pins',
            selected: !isBoardListPage,
            as: Link,
            to: DESIGN_BOARD_ALL_PINS_LINK,
            preventScrollReset: true,
        },
    ];

    return (
        <Flex className={css(S.MobileFilterWarp)}>
            <ProfileNavigation
                filterButton={navFilterButton}
                items={itemButtons || navItemButtons}
                variables={{
                    filterButtonMinWidth: pxToRem(46),
                    buttonPadding: pxArrayToRem([12, 12]),
                    buttonHeight: pxToRem(38),
                }}
            />
            <div className={css(S.NewBoardButton)}>{newBoardButton}</div>
        </Flex>
    );
};
